import {Component, OnInit, ElementRef, Inject, Input} from '@angular/core';
import {ConnecttocrudService} from '../connecttocrud.service';
import {MatSnackBar} from '@angular/material';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';

import {Data} from './class/data';
import {Model} from './class/model';
import {Schema} from './class/schema';

import {RoleDataService} from './role-service/data.service';
import {RoleJsPlumbService} from './role-service/jsPlumb.service';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import {environment} from '../../environments/environment';
import {setTime} from 'ngx-bootstrap/chronos/utils/date-setters';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AccountInfoService} from '../user/account-info.service';
import {PartnerSettingsService} from '../partnerSettings/partner-settings.service';
import {interval} from 'rxjs';
import {AdminEnvironmentHandlerService} from '../admin-environment-handler.service';

declare let $;
declare let dagre;
declare let jsPlumb: any;


export interface DialogData {
    deleteAction: string;
    type: string;
}

export interface RoleDialogData {
    name: string;
    action: string;
}

export interface ExclusionsDialogData {
    type: string;
    action: string;
    name: string;
}

@Component({
    selector: 'app-manage-roles',
    templateUrl: './manage-roles.component.html',
    styleUrls: ['./manage-roles.component.css']
})
export class ManageRolesComponent implements OnInit {

    @Input() inputPartner: any;
    @Input() inputAccount: any;
    settingsData: any;
    totalServices: any;
    permissionGroups: any;
    permissions: any;
    roles: any;
    orgchart: any;
    error: boolean;
    items: any;
    columns: any;
    itemList: any;
    options: any;
    errorMessage: string;
    searchText: any;
    itemLength: any;
    filterData: any[];
    getRoleName: string;
    operation: string;
    settings = {text: 'Select attribute(s) to search instantly'};
    userView = 'table';
    entity = 'Manage Roles';
    create = false;
    columnCopy: any;
    rightPanel = true;
    contentLoading = true;
    signInEmail = localStorage.getItem('signInEmail');

    data: Data;
    myModel: Model;
    modelPreview: Model;
    schema: Schema;
    pY: number;
    models = [];
    schemas = [];
    links = [];
    createdRoles = [];
    dbRoles = {};
    excludedPermissions = [];
    userAddedPermissionGroups = [];
    userAddedPermissions = [];
    highlightedModel: any;
    masterRole = '';
    previewPaneOpened = false;
    jsPlumbInitialized = false;
    canvasOpenable = false;
    nameInputForm = false;
    isNewRoleCreated = false;
    isNewPermissionGroupCreated = false;
    isSuperAdmin = false;
    deleteAction: 'removeFromRole';
    currentAction = '';
    currentActionName = '';
    currentRoleOnCanvas: any;
    permissionGroupSearchText: string;
    permissionSearchText: string;
    partnerShortCode: any;
    accountShortCode: any;
    roleSearchText: string;
    position = {x: 100, y: 100};
    initialPosition = {x: 100, y: 100};
    previewBlock: any;
    offset: any;
    dragStarted = false;
    previewData: Data;
    pos1 = 0;
    pos2 = 0;
    pos3 = 0;
    pos4 = 0;
    environmentData: any;

    constructor(public _service: ConnecttocrudService,
                public platform: LeftpanelComponent,
                public dataService: RoleDataService,
                public jsPlumbService: RoleJsPlumbService,
                public accountInfoService: AccountInfoService,
                private el: ElementRef,
                public dialog: MatDialog,
                private partnerSettingsService: PartnerSettingsService,
                private adminEnvironmenthandler: AdminEnvironmentHandlerService,) {
        // this.data = new Data();
        // this.previewData = new Data();
        // this.data = this.dataService.data;
        // this.jsPlumbService.init();
    }

    ngAfterViewChecked() {
        // this.populateTables();
        // this.jsPlumbService.init();
        if (this.dataService.flg_repaint) {
            this.dataService.flg_repaint = false;
            this.jsPlumbService.repaintEverything();
        }
    }



    setData(){

        this.environmentData = this.partnerSettingsService.environment;
        this.data = new Data();
        this.previewData = new Data();
        this.dataService = new RoleDataService();
        this.jsPlumbService = new RoleJsPlumbService(this.dataService);
        this.data = this.dataService.data;
        const partner = localStorage.getItem('partner').split('-');
        const account = localStorage.getItem('account').split('-');
        this.partnerShortCode = partner[partner.length - 1];
        this.accountShortCode = account[account.length - 1];

        this.inputPartner = this.environmentData.name;


        // this.jsPlumbService.init();
        // this.testBlock();
        this.error = false;
        this.loadPermissionGroups();
        this.loadPermissions();
        this.loadRoles();
        const that = this;
        $(document).on('click', '.createNode', function () {
            that.create = false;
            that.operation = 'create';
            const newNode = {'role': that.getRoleName, 'id': that.getId()};
            that.loadChart(newNode);
            that.rightPanel = true;
            that.getRoleName = null;
        });
    }

    initialise(){
        const partnerSettingsSubscription = interval(500).subscribe((async x => {
            if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
                partnerSettingsSubscription.unsubscribe();
                this.setData();

                this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
                    this.partnerSettingsService.changeEnvironment();
                    this.clearCanvas();
                    this.setData();
                });


            }else{
            }
        }));
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.initialise();

        // this.jsPlumbService.init()
    }




    loadPermissionGroups() {


        // this._service.getPermissionGroups(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.permissionGroups = data;
        //
        // });

        // this._service.getPermissionGroupswithParams(localStorage.getItem('partner'), localStorage.getItem('account'), 'services').subscribe(data => {
        //     this.permissionGroups = data;
        //
        // });
        if (this.inputPartner.includes('admin-')) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'partner.in=services,' + this.inputPartner + '&&type=platform').subscribe(data => {
                this.permissionGroups = data;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching permission groups');
            });
        } else {

            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'partner=' + this.inputPartner + '&&type=account').subscribe(data => {
                this.permissionGroups = data;

            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching permission groups');
            });
        }

    }

    loadPermissions() {
        // this._service.getAllPermissions().subscribe(response => {
        //     this.permissions = response;
        //
        // });
        // this._service.getPlatformPermissions(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.permissions = data;
        //
        // });
        // this._service.getPermissionsWithParams(localStorage.getItem('partner'), localStorage.getItem('account'), 'services').subscribe(data => {
        //     this.permissions = data;
        // });
        if (this.inputPartner.includes('admin-')) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'partner.in=services,' + this.inputPartner + '&&type=platform').subscribe(data => {
                this.permissions = data;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching permissions');
            });
        } else {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissions', 'partner=' + this.inputPartner + '&&type=account').subscribe(data => {
                this.permissions = data;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching permissions');
            });
        }

    }

    loadRoles() {
        // this._service.getAllRoles().subscribe(response => {
        //     this.roles = response;
        //     for (const role of this.roles) {
        //         this.dbRoles[role.role] = role.id;
        //     }
        // });


        if (this.inputPartner.includes('admin-')) {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=' + this.inputPartner + '&&type.in=account').subscribe(data => {
                this.roles = data;
                // this.roles = this.roles.filter((v, i) => v.role !== 'Super Admin' && !v.role.includes('services@apiplatform.io'));
                // if (this.roles) {
                //     for (const role of this.roles) {
                //         this.dbRoles[role.role] = role.id;
                //     }
                // }
                // this.contentLoading = false;
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services' + '&&type.in=platform').subscribe(response => {
                    let tempRoles: any;
                    tempRoles = response;
                    if (this.roles && this.roles.length) {
                        this.roles = this.roles.concat(tempRoles);
                    } else {
                        this.roles = tempRoles;
                    }
                    this.roles = this.roles.filter((v, i) => v.role !== 'Super Admin' && !v.role.includes('services@apiplatform.io'));
                    if (this.roles) {
                        for (const role of this.roles) {
                            this.dbRoles[role.role] = role.id;
                        }
                    }
                    this.contentLoading = false;
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while fetching platform roles');
                    if (this.roles && this.roles.length) {
                        for (const role of this.roles) {
                            this.dbRoles[role.role] = role.id;
                        }
                    }
                    this.contentLoading = false;
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching roles');
                this.contentLoading = false;
            });
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'user=' + this.inputPartner).subscribe(response => {
                const user = response;
                if (user[0] && user[0].environments.length) {
                    const environment = user[0].environments.filter((v, i) => v.name === this.inputPartner);
                    if (environment && environment[0]) {
                        if (environment[0].roles.includes(6)) {
                            this.isSuperAdmin = true;
                        } else {
                            this.isSuperAdmin = false;
                        }
                    }
                }
            });
        } else {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=' + this.inputPartner + '&&type=account').subscribe(data => {
                this.roles = data;
                if (this.roles) {
                    for (const role of this.roles) {
                        this.dbRoles[role.role] = role.id;
                    }
                }
                this.contentLoading = false;
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching roles');
                this.contentLoading = false;
            });
        }
    }

    loadChart(datascource) {
        const that = this;
        $('#chart-container').html('');
        $('.permisionGroupSection').html('');
        $('.deleteNode').html('');
        $('#saveChanges').remove();
        $(function () {
            that.orgchart = $('#chart-container').orgchart({
                'data': datascource,
                'nodeContent': 'title',
                'draggable': true,
                'partner': localStorage.getItem('partner'),
                'account': localStorage.getItem('account'),
                'pkey': localStorage.getItem('partnerKey'),
                'module': 'permissiongroups',
                'dropCriteria': function ($draggedNode, $dragZone, $dropZone) {
                    if ($draggedNode.find('.content').text().indexOf('manager') > -1 && $dropZone.find('.content').text().indexOf('engineer') > -1) {
                        return false;
                    }
                    return true;
                }
            });
            const oc = that.orgchart;
            oc.$chart.on('nodedrop.orgchart', function (event, extraParams) {
            });

            that.permissionGroups.forEach((data) => {
                data.level = 2;
                data.parentId = 2;
                const nodeData = $.extend({}, data);
                const $nodediv = $('<td colspan="2" style="display: grid;" class="drag-panel"><table><tr><td>' +
                    '<div class="node drag-panel" data-parent="2" draggable="true">' +
                    '<div class="title" style="word-break: break-word;padding: 3px;" id= "' + data.id + '">' +
                    data.permissionGroup + '</div></div>' +
                    '</td></tr></table></td>'
                );
                $nodediv.data('nodeData', nodeData);

                oc.bindDragDrop($nodediv);
                $('.permisionGroupSection').append($nodediv);
            });
            const $savebtn = $('<button _ngcontent-c5="" id="saveChanges" class="confap-button mat-stroked-button" mat-stroked-button=""><span class="mat-button-wrapper"> Save </span><div class="mat-button-ripple mat-ripple" matripple="" ng-reflect-centered="false" ng-reflect-disabled="false" ng-reflect-trigger="[object HTMLButtonElement]"></div><div class="mat-button-focus-overlay"></div></button>');
            $savebtn.click(function () {
                that.updateRole(oc.getHierarchy('roles'));
            });
            $('.chart-contain').append($savebtn);
            const $node = $('<i class="fa fa-trash"  style="float: initial;font-size: 25px;color:#505050"></i>');
            oc.bindRemoveDrop($node);
            $node.addClass('allowedDrop');
            $('.deleteNode').append($node);

            $(document).on('keyup', '.filterText', function () {
                oc.searchFilter();
            });

            $(document).on('click', '.cancelNode', function () {
                that.create = false;
                $('.table-responsive').attr('class', 'table-responsive col-md-12');
                $('.visual-editor').hide();
                //   that.loadChartById(datascource);
                //   that.columns = that.columnCopy;
            });

        });
    }

    getPermissionGroup(id) {
        let result;
        this._service.getPermissionGroup(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(data => {
            result = data;
        });
        return result;
    }

    updateRole(data) {
        // if (this.operation == 'update') {
        //     this._service.UpdateRole(localStorage.getItem('partner'),
        //         localStorage.getItem('account'), data).subscribe(updated => {
        //         this.platform.openSnackBar('Updated successfully', 'Success', {
        //             duration: 2000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //     });
        // } else {
        //     delete data.id;
        //     data.partner = localStorage.getItem('partner');
        //     data.account = localStorage.getItem('account');
        //     this._service.InsertRole(localStorage.getItem('partner'),
        //         localStorage.getItem('account'), data).subscribe(entry => {
        //         //  this.items.push(entry);
        //         this.platform.openSnackBar('Created successfully', 'Success', {
        //             duration: 2000,
        //             verticalPosition: 'top',
        //             horizontalPosition: 'center'
        //         });
        //     });
        // }

    }

    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        return JSON.stringify(val, null, 2).trim();
    }

    getRole(id) {
        this.create = false;
        $('.table-responsive').attr('class', 'table-responsive col-md-2');
        $('.visual-editor').show();
        //  this.columns = ['role'];
        this.operation = 'update';
        this._service.getRole(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(data => {
            this.loadChart(data);
        });
    }

    openNameInputForm(action, name = '') {
        this.nameInputForm = true;
        this.currentAction = action;
        this.currentActionName = name;
        const dialogRef = this.dialog.open(NewRoleDialogComponent, {
            width: '250px',
            data: {name: this.currentActionName, action: this.currentAction}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.currentActionName = result;
            this.closeNameInputForm();
        });
    }


    async closeNameInputForm() {
        this.nameInputForm = false;
        if (this.currentActionName && this.currentActionName !== '' && this.currentActionName !== '') {
            if (this.currentAction === 'Role') {
                const res = await this.checkDuplicate('roles', 'role', this.currentActionName);
                if (!res) {
                    this.clearCanvas();
                    this.masterRole = this.currentActionName;
                    this.createNewRole(this.currentActionName);
                    this.isNewRoleCreated = true;
                    setTimeout(() => {
                        this.tryArrangeBlocks(true);
                    }, 1000);
                } else {
                    this.platform.openSnackBar('Role named ' + this.currentActionName + ' alredy exsists', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.openNameInputForm('Role', this.currentActionName);
                }
            }
            if (this.currentAction === 'Permission Group') {
                const res = await this.checkDuplicate('permissiongroups', 'permissionGroup', this.currentActionName);
                if (!res) {
                    this.clearCanvas();
                    this.createNewPermissionGroup(this.currentActionName);
                    setTimeout(() => {
                        this.tryArrangeBlocks(true);
                    }, 1000);
                } else {
                    this.platform.openSnackBar('Permission group named ' + this.currentActionName + ' alredy exsists', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.openNameInputForm('Permission Group', this.currentActionName);
                }
            }
            if (this.currentAction === 'Permission') {
                const res = await this.checkDuplicate('permissions', 'permission', this.currentActionName);
                if (!res) {
                    this.saveNewPermission();
                } else {
                    this.platform.openSnackBar('Permission named ' + this.currentActionName + ' alredy exsists', 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.openNameInputForm('Permission', this.currentActionName);
                }
            }
        }

    }

    saveNewPermission() {
        const payload = {
            'permission': this.currentActionName,
            'display_name': this.currentActionName,
            'partner': this.inputPartner,
            'account': this.inputAccount,
            'type': this.isSuperAdmin && this.inputPartner.includes('admin-') ? 'platform' : 'account'
        };
        this._service.addItem(payload, 'v1', 'access', 'access', 'permissions').subscribe(result => {
            this.platform.openSnackBar('Permission added successfully.', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loadPermissions();
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while adding the permission. Please try again after sometime.');
        });
    }

    createNewPermissionGroup(permissionGroupName) {
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init(this.dataService);
            this.jsPlumbInitialized = true;
        }
        this.masterRole = permissionGroupName;
        this.isNewPermissionGroupCreated = true;
        this.myModel = new Model();
        this.myModel.name = permissionGroupName;
        this.myModel.display_name = permissionGroupName;
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = true;
        this.myModel.type = 'permissionGroup';
        this.myModel.belongsTo = '';
        this.dataService.addModel(this.myModel);
        // this.models.push(this.myModel);

        setTimeout(() => {
            this.jsPlumbService.initModel(this.myModel);
        }, 1000);
    }

    createNewRole(roleName, posX = 600, posY = 100, parentRole = '') {
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init(this.dataService);
            this.jsPlumbInitialized = true;
        }

        this.myModel = new Model();
        this.myModel.name = roleName;
        this.myModel.display_name = roleName;
        this.myModel.previewBlock = false;
        this.myModel.type = 'role';
        this.myModel.belongsTo = parentRole !== '' ? 'Roles' : '';
        this.myModel.parentRole = parentRole;
        this.myModel.use_soft_delete = false;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        const from = this.myModel.getElementId();
        if (parentRole !== '') {
            const roleModels = this.dataService.getModelsByName('Roles');
            const filtered_models = roleModels.filter((v, i) => v.type === parentRole);
            this.links.push({from: filtered_models[0].getElementId(), to: this.myModel.getElementId()});
        }


        this.myModel = new Model();
        this.myModel.name = 'Permission Groups';
        this.myModel.display_name = 'Permission Groups';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = roleName;
        this.myModel.belongsTo = roleName;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


        this.myModel = new Model();
        this.myModel.name = 'Permissions';
        this.myModel.display_name = 'Permissions';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = roleName;
        this.myModel.belongsTo = roleName;
        // this.myModel.parentRole = roleName;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});

        this.myModel = new Model();
        this.myModel.name = 'Roles';
        this.myModel.display_name = 'Roles';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = roleName;
        this.myModel.belongsTo = roleName;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


        this.myModel = new Model();
        this.myModel.name = 'Exclusions';
        this.myModel.display_name = 'Exclusions';
        this.myModel.use_soft_delete = false;
        this.myModel.previewBlock = false;
        this.myModel.type = roleName;
        this.myModel.belongsTo = roleName;
        this.dataService.addModel(this.myModel);
        this.models.push(this.myModel);
        this.links.push({from: from, to: this.myModel.getElementId()});


    }

    closeModelPreview() {
        this.previewPaneOpened = false;
        // drawer.toggle();
    }

    createPermissionBlock(permission, belongsTo = '') {
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init(this.dataService);
            this.jsPlumbInitialized = true;
        }
        this.previewPaneOpened = true;
        this.modelPreview = new Model();
        this.modelPreview.name = permission;
        this.modelPreview.display_name = permission;
        this.modelPreview.use_soft_delete = false;
        this.modelPreview.previewBlock = true;
        this.modelPreview.type = 'permission';
        this.modelPreview.belongsTo = belongsTo;
        // this.modelPreview.pos_x = 0;
        // this.modelPreview.pos_y = 24;


        this.modelPreview.id = this.data.getNewModelId();
        // this.jsPlumbService.initModel(this.modelPreview);
        this.previewBlock = this.modelPreview;
    }

    createPermissionGroupBlock(permissionGroup, belongsTo = '') {
        this.previewPaneOpened = true;
        this.isNewPermissionGroupCreated = false;
        if (!this.jsPlumbInitialized) {
            this.jsPlumbService.init(this.dataService);
            this.jsPlumbInitialized = true;
        }
        this.masterRole = permissionGroup.permissionGroup;
        this.currentAction = 'Permission Group';
        this.currentActionName = permissionGroup.permissionGroup;
        this.modelPreview = new Model();
        this.modelPreview.name = permissionGroup.permissionGroup;
        this.modelPreview.display_name = permissionGroup.display_name && permissionGroup.display_name !== '' ? permissionGroup.display_name : permissionGroup.permissionGroup;
        this.modelPreview.use_soft_delete = false;
        this.modelPreview.previewBlock = true;
        this.modelPreview.type = 'permissionGroup';
        this.modelPreview.belongsTo = belongsTo;
        this.modelPreview.dbId = permissionGroup.id;
        this.dataService.addModel(this.modelPreview);
        // this.modelPreview.pos_x = 0;
        // this.modelPreview.pos_y = 24;

        for (const permission of permissionGroup.permissions) {
            const schema = new Schema();
            schema.name = permission['permission'];
            schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
            
            schema.type = 'text';
            schema.input_type = 'text';
            schema.dbId = permission.id;
            schema.parent_id = this.modelPreview.id;
            // this.modelPreview.schemas.push(schema);
            this.dataService.addSchema(schema);
        }

        setTimeout(() => {
            this.jsPlumbService.initModel(this.modelPreview);
        }, 1000);


        // this.previewBlock = this.modelPreview;
    }

    createSubRoles(role) {
        for (const cRole of role.roles) {
            if (cRole.role) {
                this.createRoleBlock(cRole, 0, 0, role.role);
                this.createdRoles.push(cRole.role);
                this.createSubRoles(cRole);
            }
        }

    }

    createExistingRole(role) {
        if (!this.createdRoles.includes(role.role)) {
            this.currentAction = 'Role';
            this.currentRoleOnCanvas = role;
            this.isNewRoleCreated = false;
            if (this.masterRole === '') {
                this.masterRole = role.role;
                this.createRoleBlock(role);
            } else {
                this.createRoleBlock(role, 0, 0, this.masterRole);
            }
            // this.masterRole = this.masterRole === '' ? role.role : this.masterRole;
            // this.createRoleBlock(role);
            this.createdRoles.push(role.role);
            this.createSubRoles(role);
            // for (const cRole of role.roles) {
            //     if (cRole.role) {
            //         this.createRoleBlock(cRole, 0, 0, role.role);
            //         this.createdRoles.push(cRole.role);
            //     }
            // }
            //
            if (!this.isNewRoleCreated) {
                setTimeout(() => {
                    // this.arrangeBlocks();
                    this.tryArrangeBlocks(true);
                }, 1000);
            }

            this.canvasOpenable = true;
        }

    }

    createRoleBlock(role, posX = 600, posY = 100, parentRole = '') {
        // this.models = [];
        this.createNewRole(role.role, posX, posY, parentRole);
        const permissionGroupModels = this.dataService.getModelsByName('Permission Groups');
        let filtered_models = permissionGroupModels.filter((v, i) => v.type === role.role);
        const permissionGroups_posX = filtered_models[0].pos_x;
        const permissionGroups_posY = filtered_models[0].pos_y;
        let count = role.permission_groups.length / 2;
        for (const permissionGroup of role.permission_groups) {
            // this.createPermissionGroupBlock(permissionGroup, role.role);
            this.modelPreview = new Model();
            this.modelPreview.name = permissionGroup.permissionGroup;
            // this.modelPreview.display_name = permissionGroup.permissionGroup;
            this.modelPreview.display_name = permissionGroup.display_name && permissionGroup.display_name !== '' ? permissionGroup.display_name : permissionGroup.permissionGroup;
            this.modelPreview.use_soft_delete = false;
            this.modelPreview.previewBlock = false;
            this.modelPreview.type = 'permissionGroup';
            this.modelPreview.belongsTo = 'Permission Groups';
            this.modelPreview.parentRole = role.role;
            this.modelPreview.dbId = permissionGroup.id;
            this.modelPreview.id = this.dataService.data.getNewModelId();
            // this.dataService.addModel(this.modelPreview);
            // this.models.push(this.modelPreview);
            // this.links.push({from: filtered_models[0].getElementId(), to: this.modelPreview.getElementId()});
            count = count - 1;
            for (const permission of permissionGroup.permissions) {
                const schema = new Schema();
                schema.name = permission['permission'];
                // schema.display_name = permission['permission'];
                schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                schema.type = 'text';
                schema.input_type = 'text';
                schema.parent_id = this.modelPreview.id;
                schema.dbId = permission.id;
                schema.id = this.modelPreview.getNewSchemaId();
                this.modelPreview.schemas.push(schema);
                // this.dataService.addSchema(schema);

            }
            this.userAddedPermissionGroups.push(permissionGroup.permissionGroup);
            filtered_models[0].childModels.push(this.modelPreview);

        }
        const permissionModels = this.dataService.getModelsByName('Permissions');
        filtered_models = permissionModels.filter((v, i) => v.type === role.role);
        const permission_posX = filtered_models[0].pos_x;
        const permission_posY = filtered_models[0].pos_y;
        const permissionCount = role.permissions.length / 2;
        for (const permission of role.permissions) {
            const schema = new Schema();
            schema.name = permission.permission;
            // schema.display_name = permission.permission;
            schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
            schema.dbId = permission.id;
            schema.type = 'text';
            schema.input_type = 'text';
            schema.parent_id = filtered_models[0].id;
            this.userAddedPermissions.push(permission.permission);
            this.dataService.addSchema(schema);
        }

        const exclusionModels = this.dataService.getModelsByName('Exclusions');
        filtered_models = exclusionModels.filter((v, i) => v.type === role.role);
        for (const exclusion of role.exclusions) {
            const schema = new Schema();
            schema.name = exclusion.permission;
            // schema.display_name = exclusion.permission;
            schema.display_name = exclusion.display_name && exclusion.display_name !== '' ? exclusion.display_name : exclusion.permission;
            schema.dbId = exclusion.id;
            schema.type = 'text';
            schema.input_type = 'text';
            schema.parent_id = filtered_models[0].id;
            if (filtered_models[0].type === this.masterRole) {
                this.excludedPermissions.push(exclusion.permission);
            }
            this.dataService.addSchema(schema);
        }

        const roleModels = this.dataService.getModelsByName('Roles');
        filtered_models = roleModels.filter((v, i) => v.type === role.role);
        const role_posX = filtered_models[0].pos_x;
        const role_posY = filtered_models[0].pos_y;
        // let roleCount = role.roles.length / 2;
        // for (const currentRole of role.roles) {
        //     roleCount = roleCount - 1;
        //     this.createRoleBlock(currentRole, role_posX - (roleCount * 150), role_posY + 100, role.role);
        // }
    }


    tryArrangeBlocks(isNew) {
        const $container = $('.modelPane');
        const $diagram = $container.find('.diagram');
        const plumb = null;
        const that = this;
        const dg = new dagre.graphlib.Graph();
        dg.setGraph({nodesep: 80, ranksep: 50, marginx: 50, marginy: 50});
        dg.setDefaultEdgeLabel(function () {
            return {};
        });
        $container.find('.item').each(
            function (idx, node) {
                const $n = $(node);
                const box = {
                    width: Math.round($n.outerWidth()),
                    height: Math.round($n.outerHeight())
                };
                dg.setNode($n.attr('id'), box);
            }
        );

        // for (const model of that.models) {
        //     var $n = $(document.getElementById(model.getElementId()));
        //     var box = {
        //         width: Math.round($n.outerWidth()),
        //         height: Math.round($n.outerHeight())
        //
        //     };
        //     dg.setNode($n.attr('id'), box);
        // }

        // for (const model of that.data.models) {
        //     const targetIds = that.jsPlumbService.getAllConnections(model);
        //     if (targetIds.length) {
        //         for (const targetId of targetIds) {
        //             dg.setEdge(model.getElementH2Id(), targetId);
        //         }
        //
        //     }
        // }
        // for (const rRole of that.createdRoles) {
        //     console.log('loop');
        //     if (that.dataService.getModelByName(rRole.role).parentRole !== '') {
        //         console.log('if');
        //         const roleModels = that.dataService.getModelsByName('Roles');
        //         var filtered_models = roleModels.filter((v, i) => v.type === rRole.role);
        //         that.links.push({from: filtered_models[0].getElementId(), to: that.dataService.getModelByName(rRole.role).getElementId()});
        //         console.log('if');
        //     }
        //
        // }
        for (const link of that.links) {
            dg.setEdge(link.from, link.to);
        }

        // plumb.getAllConnections()
        //     .forEach(function (edge) {
        //         dg.setEdge(edge.source.id, edge.target.id);
        //     });
        dagre.layout(dg);
        const graphInfo = dg.graph();
        dg.nodes().forEach(
            function (n) {
                const node = dg.node(n);
                const top = Math.round(node.y - node.height / 2) + 'px';
                const left = Math.round(node.x - node.width / 2) + 'px';
                $('#' + n).css({left: left, top: top});
                // if (that.dataService.getModelByElementId(n)) {
                //     that.dataService.getModelByElementId(n).pos_x = Math.round(node.x - node.width / 2);
                //     that.dataService.getModelByElementId(n).pos_y = Math.round(node.y - node.height / 2);
                // }
                // that.jsPlumbService.repaintEverything();
                // that.models.filter((v, i) => {
                //     if (v.getElementId() === n) {
                //         v.pos_x = Math.round(node.x - node.width / 2);
                //         v.pos_y = Math.round(node.y - node.height / 2);
                //     }
                // });
            });
        if (isNew) {
            setTimeout(() => {
                for (const model of that.models) {
                    that.jsPlumbService.initModel(model);
                }
                this.models = [];
                // this.links = [];
            }, 1000);

        } else {
            setTimeout(() => {
                for (const link of that.links) {
                    // that.jsPlumbService.createConnection(that.dataService.getModelByElementId(link.from), that.dataService.getModelByElementId(link.to));
                }
                // that.jsPlumbService.toggleDraggable(that.dataService.getModelByElementId('model1'));
                // for (const model of that.models) {
                //     that.jsPlumbService.addToDragSelection(document.getElementById(model.getElementId()));
                //     that.dataService.getModelByElementId('model1').pos_x += 5;
                //     //that.dataService.getModelByElementId('model1').pos_y += 5;
                // }

            }, 3000);

        }
        // that.jsPlumbService.repaintEverything();
    }


    previewBlockDragStarted(event) {
        this.dragStarted = true;

        this.initialPosition = {
            x: document.getElementById('previewBlock').offsetLeft,
            y: document.getElementById('previewBlock').offsetTop
        };
        this.jsPlumbService.toggleDraggableDiv('previewBlock');
    }

    previewBlockDragStopped(model) {
        this.dragStarted = false;
        // this.jsPlumbService.toggleDraggableDiv('previewBlock');
        const element = document.getElementById('previewBlock');
        this.initialPosition.x = this.position.x;
        this.initialPosition.y = this.position.y;
    }

    mouseMoving(event) {
        if (this.dragStarted) {
            if (window.innerWidth - event.clientX + this.initialPosition.x < document.getElementById('previewBlock').offsetWidth) {
                this.position.x = window.innerWidth - document.getElementById('previewBlock').offsetWidth;
            }
            if (event.clientY > window.innerHeight - document.getElementById('previewBlock').offsetHeight + this.initialPosition.y) {
                this.position.y = window.innerHeight - document.getElementById('previewBlock').offsetHeight;
            }
            // draggable.style.left = cx + 'px';
            // draggable.style.top = cy + 'px';
            // let position = {x: event.clientX - this.initialPosition.x, y: event.clientY - this.initialPosition.y};
        }

    }

    droppedOnCanvas() {
    }

    dragEnded($event: CdkDragEnd) {

        // console.log(this.el.nativeElement.querySelectorAll('#' + 'previewBlock')[0].style.left);

    }

    onDragStopped(model) {
        //  jsPlumb.addToGroup('roleGroup', document.getElementById('model2'));
        //  jsPlumb.addToGroup('roleGroup', this.el.nativeElement.querySelectorAll('#model3')[0]);
        //  jsPlumb.addToGroup('roleGroup', this.el.nativeElement.querySelectorAll('#model4')[0]);
        // jsPlumb.collapseGroup('roleGroup');
        jsPlumb.hide(this.el.nativeElement.querySelectorAll('#' + model.getElementId())[0]);
        // console.log(document.getElementById('modelPreview'));
        if (model.previewBlock && model.pos_x >= document.getElementById('modelPreview').offsetLeft) {
            this.modelPreview.pos_x = model.pos_x - document.getElementById('modelPreview').offsetLeft;
            this.modelPreview.pos_y = model.pos_y;

            this.modelPreview.previewBlock = false;
            const newModel = new Model();
            newModel.name = this.modelPreview.name;
            newModel.display_name = this.modelPreview.display_name;
            newModel.use_soft_delete = false;
            newModel.previewBlock = false;
            newModel.type = model.type;
            newModel.pos_x = this.modelPreview.pos_x;
            newModel.pos_y = this.modelPreview.pos_y;
            this.dataService.addModel(newModel);


            for (const permission of this.modelPreview.schemas) {
                const schema = new Schema();
                schema.name = permission.name;
                schema.display_name = permission.name;
                schema.type = 'text';
                schema.input_type = 'text';
                const models = this.dataService.getModelsByName(newModel.name);
                schema.parent_id = models[models.length - 1].id;
                this.dataService.addSchema(schema);
            }
            this.previewPaneOpened = false;
            setTimeout(() => {
                this.jsPlumbService.initModel(newModel);
            }, 1000);

            // this.jsPlumbService.repaintEverything();

        } else if (model.belongsTo === '') {
            if (model.type === 'permissionGroup') {
                const permissionGroupModels = this.data.getModelsByName('Permission Groups');
                // for (const permissionGroupModel of permissionGroupModels) {
                if (permissionGroupModels.length) {
                    const permissionGroupModel = permissionGroupModels[0];
                    const permissionGroupBlock = document.getElementById(permissionGroupModel.getElementId());
                    const xStart = permissionGroupBlock.offsetLeft;
                    const xEnd = permissionGroupBlock.offsetLeft + permissionGroupBlock.offsetWidth;
                    const yStart = permissionGroupBlock.offsetTop;
                    const yEnd = permissionGroupBlock.offsetTop + permissionGroupBlock.offsetHeight;
                    if (((model.pos_x >= xStart) && (model.pos_x <= (xEnd))) && ((model.pos_y >= yStart) && (model.pos_y <= (yEnd)))) {
                        model.pos_x = xStart;
                        model.pos_y = yStart + 150;
                        model.type = 'permissionGroup';
                        model.belongsTo = 'Permission Groups';
                        model.parentRole = permissionGroupModel.type;
                        this.jsPlumbService.createConnection(permissionGroupModel, model);
                        this.links.push({from: permissionGroupModel.getElementId(), to: model.getElementId()});
                        this.tryArrangeBlocks(false);
                        setTimeout(() => {
                            for (const dmodel of this.models) {

                                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                            }
                            this.jsPlumbService.repaintEverything();
                        }, 1000);
                        // break;

                        // this.jsPlumbService.repaintEverything();
                    }
                }

                // }

            } else if (model.type === 'permission') {
                let permissionModels = [];
                permissionModels = this.data.getModelsByName('Permissions');
                permissionModels = permissionModels.concat(this.data.getModelsByType('permissionGroup'));
                for (const permissionModel of permissionModels) {
                    const permissionBlock = document.getElementById(permissionModel.getElementId());
                    const xStart = permissionBlock.offsetLeft;
                    const xEnd = permissionBlock.offsetLeft + permissionBlock.offsetWidth;
                    const yStart = permissionBlock.offsetTop;
                    const yEnd = permissionBlock.offsetTop + permissionBlock.offsetHeight;
                    if (((model.pos_x >= xStart) && (model.pos_x <= (xEnd))) && ((model.pos_y >= yStart) && (model.pos_y <= (yEnd)))) {
                        model.pos_x = xStart;
                        model.pos_y = yStart + 150;
                        model.belongsTo = 'Permissions';
                        const schema = new Schema();
                        schema.name = model.name;
                        schema.display_name = model.name;
                        schema.type = 'text';
                        schema.input_type = 'text';
                        schema.parent_id = permissionModel.id;
                        this.dataService.addSchema(schema);
                        this.dataService.deleteModel(model.id);
                        if (permissionModel.belongsTo !== '') {
                            this.tryArrangeBlocks(false);
                            setTimeout(() => {
                                for (const dmodel of this.models) {
                                    this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                                }
                                this.jsPlumbService.repaintEverything();
                            }, 1000);
                        }
                        break;
                    }
                }
            } else if (model.type === 'role') {
                const roleModels = this.data.getModelsByName('Roles');
                for (const roleModel of roleModels) {
                    const roleBlock = document.getElementById(roleModel.getElementId());
                    const xStart = roleBlock.offsetLeft;
                    const xEnd = roleBlock.offsetLeft + roleBlock.offsetWidth;
                    const yStart = roleBlock.offsetTop;
                    const yEnd = roleBlock.offsetTop + roleBlock.offsetHeight;
                    if (((model.pos_x >= xStart) && (model.pos_x <= (xEnd))) && ((model.pos_y >= yStart) && (model.pos_y <= (yEnd)))) {
                        model.pos_x = xStart;
                        model.pos_y = yStart + 150;
                        model.belongsTo = 'Roles';
                        this.jsPlumbService.createConnection(roleModel, model);
                        this.links.push({from: roleModel.getElementId(), to: model.getElementId()});
                        this.tryArrangeBlocks(false);
                        setTimeout(() => {
                            for (const dmodel of this.models) {
                                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                            }
                            this.jsPlumbService.repaintEverything();
                        }, 1000);
                    }
                }
            }

        }
    }

    deleteRole(model) {
        const conns = this.jsPlumbService.getAllConnections(model);
        this.createdRoles = this.createdRoles.filter((v, i) => v !== model.name);
        this.jsPlumbService.deleteModel(model);
        this.models = this.models.filter((v, i) => v.id !== model.id);
        this.links = this.links.filter((v, i) => v.to !== model.getElementId());
        for (const conn of conns) {
            const nextModel = this.dataService.getModelByElementH2Id(conn);
            if (nextModel) {
                this.jsPlumbService.addToDragSelection(document.getElementById(model.getElementId()));
                this.deleteRole(nextModel);
            }
        }
        this.tryArrangeBlocks(false);
        setTimeout(() => {
            for (const dmodel of this.models) {
                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
            }
            this.jsPlumbService.repaintEverything();
        }, 1000);
    }

    onDeletingModel(model) {
        if ((model.type === 'role' && model.name === this.masterRole) || model.previewBlock) {
            this.clearCanvas();
        } else if ((model.type === 'role' && model.name !== this.masterRole) || (model.name === 'Permission Groups')) {
            // const conns = this.jsPlumbService.getAllConnections(model);
            // this.createdRoles = this.createdRoles.filter((v, i) => v !== model.name);
            // this.jsPlumbService.deleteModel(model);
            // this.models = this.models.filter((v, i) => v.id !== model.id);
            // this.links = this.links.filter((v, i) => v.to !== model.getElementId());
            // for (const conn of conns) {
            //     const nextModel = this.dataService.getModelByElementH2Id(conn);
            //     if (nextModel) {
            //         this.jsPlumbService.addToDragSelection(document.getElementById(model.getElementId()));
            //         this.onDeletingModel(nextModel);
            //     }
            // }
            this.deleteRole(model);
            // model.type = '';
            // this.onDeletingModel(model);
        } else if (model.type === 'permissionGroup' && model.parentRole === this.masterRole) {
            const dialogRef = this.dialog.open(DeletePermissionGroupDialogComponent, {
                width: '250px',
                data: {deleteAction: this.deleteAction, type: 'Permission Group'}
            });

            dialogRef.afterClosed().subscribe(result => {
                this.deleteAction = result;
                if (this.deleteAction === 'removeFromRole') {
                    this.jsPlumbService.deleteModel(model);
                    this.models = this.models.filter((v, i) => v.id !== model.id);
                    this.links = this.links.filter((v, i) => v.to !== model.getElementId());
                    const permissionGroupModel = this.dataService.getModelByName('Permission Groups');
                    permissionGroupModel.childModels = permissionGroupModel.childModels.filter((v, i) => v.id !== model.id);
                    this.userAddedPermissionGroups = this.userAddedPermissionGroups.filter((v, i) => v !== model.name);
                    const exclusion = this.dataService.getModelByName('Exclusions');
                    for (const permission of exclusion.schemas) {
                        if (permission['old_id'] && permission['old_id'] === model.id) {
                            this.excludedPermissions = this.excludedPermissions.filter((v, i) => v !== permission.name);
                            this.dataService.deleteSchema(permission);
                        }
                    }
                    this.tryArrangeBlocks(false);
                    setTimeout(() => {
                        for (const dmodel of this.models) {
                            this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                        }
                        this.jsPlumbService.repaintEverything();
                    }, 1000);
                } else if (this.deleteAction === 'excludePermissions') {
                    this.setExcludedStyle(model.name, 'set');
                    for (const permission of model.schemas) {
                        if (!this.excludedPermissions.includes(permission.name)) {
                            // const exclusion = this.dataService.getModelByName('Exclusions');
                            // permission['old_id'] = permission.parent_id;
                            // permission.parent_id = exclusion.id;
                            // this.setPermissionExcludedStyle(permission.name, 'set');
                            // this.excludedPermissions.push(permission.name);
                            // this.dataService.addSchema(permission);


                            const schema = new Schema();
                            schema.name = permission.name;
                            schema.display_name = permission.display_name;
                            schema.type = 'text';
                            schema.input_type = 'text';
                            // let filtered_models = this.dataService.getModelsByName(permissionGroup.permissionGroup).filter((v, i) => v.parentRole === role.role);
                            // schema.parent_id = filtered_models[0].id;
                            const exclusions = this.dataService.getModelsByName('Exclusions');
                            // const exec = exclusions.filter((v, i) => v.belongsTo === this.dataService.getModelById(permission.parent_id).parentRole);
                            schema.dbId = permission.dbId;
                            schema['old_id'] = permission.parent_id;
                            schema.parent_id = exclusions[0].id;
                            // this.modelPreview.schemas.push(schema);
                            this.dataService.addSchema(schema);
                            this.setPermissionExcludedStyle(permission.name, 'set');
                            this.excludedPermissions.push(permission.name);
                        }
                    }
                }
            });
        } else if (model.type !== 'role') {
            this.jsPlumbService.deleteModel(model);
            this.models = this.models.filter((v, i) => v.id !== model.id);
            this.links = this.links.filter((v, i) => v.to !== model.getElementId());

            this.tryArrangeBlocks(false);
            setTimeout(() => {
                for (const dmodel of this.models) {
                    this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                }
                this.jsPlumbService.repaintEverything();
            }, 1000);
        }

        // const exclusions = this.dataService.getModelsByName('Exclusions');
        // const exec = exclusions.filter((v, i) => v.belongsTo === model.parentRole);
        // this.jsPlumbService.createConnection(exec[0], model);
        // const link = this.links.filter(function (v, i) {
        //     if (v.to === model.getElementId()) {
        //         //this.links.splice(i, 1);
        //     }
        // });
        // this.links.push({from: exec[0].getElementId(), to: model.getElementId()});
        // this.tryArrangeBlocks(false);
        // setTimeout(() => {
        //     for (const dmodel of this.models) {
        //
        //         this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
        //     }
        //     this.jsPlumbService.repaintEverything();
        // }, 1000);
    }


    setExcludedStyle(name, action) {
        const permissionGroups = this.dataService.getModelsByName('Permission Groups');
        if (permissionGroups) {
            for (const permissionGroup of permissionGroups) {
                if (permissionGroup.type !== 'Exclusions') {
                    for (const childModel of permissionGroup.childModels) {
                        if (childModel.name === name) {
                            const excludedDiv = document.getElementById(childModel.getElementH2Id());
                            if (excludedDiv && action === 'set') {
                                excludedDiv.style.backgroundColor = 'lightgray';
                                excludedDiv.style.color = 'black';
                                excludedDiv.style.fontWeight = 'bolder';
                                excludedDiv.style.textDecoration = 'line-through';
                                excludedDiv.style.opacity = '0.5';

                            } else if (excludedDiv && action === 'reset') {
                                excludedDiv.style.backgroundColor = '';
                                excludedDiv.style.color = 'white';
                                excludedDiv.style.fontWeight = '';
                                excludedDiv.style.textDecoration = 'none';
                                excludedDiv.style.opacity = '1';
                            }
                        }
                    }
                }
            }
        }
    }

    setPermissionExcludedStyle(name, action) {
        const permissionGroups = this.dataService.getModelsByName('Permission Groups');
        if (permissionGroups) {
            for (const permissionGroup of permissionGroups) {
                if (permissionGroup.type !== 'Exclusions') {
                    for (const childModel of permissionGroup.childModels) {
                        for (const exSchema of childModel.schemas) {
                            if (exSchema.name === name) {
                                if (action === 'set') {
                                    document.getElementById(exSchema.getElementId()).style.textDecoration = 'line-through';
                                } else {
                                    this.setExcludedStyle(childModel.name, 'reset');
                                    document.getElementById(exSchema.getElementId()).style.textDecoration = '';
                                }
                            }
                        }
                    }
                }
            }
        }
        const permissionBlocks = this.dataService.getModelsByName('Permissions');
        if (permissionBlocks) {
            for (const permissionBlock of permissionBlocks) {
                if (permissionBlock.type !== 'Exclusions') {
                    for (const exPermission of permissionBlock.schemas) {
                        if (exPermission.name === name) {
                            if (action === 'set') {
                                document.getElementById(exPermission.getElementId()).style.textDecoration = 'line-through';
                            } else {
                                document.getElementById(exPermission.getElementId()).style.textDecoration = '';
                            }
                        }
                    }
                }
            }
        }
    }


    onDeletingPermission(permission) {
        const parentModel = this.dataService.getModelById(permission.parent_id);
        if (parentModel && parentModel.previewBlock) {
            this.dataService.deleteSchema(permission);
        } else if (parentModel && parentModel.name === 'Exclusions' && parentModel.type === this.masterRole) {
            const dialogRef = this.dialog.open(ConfirmExclusionsDialogComponent, {
                width: '500px',
                data: {type: 'Permission', action: 'remove', name: permission.display_name}
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    const schema = new Schema();
                    schema.name = permission.name;
                    schema.display_name = permission.display_name;
                    schema.type = 'text';
                    schema.input_type = 'text';
                    // let filtered_models = this.dataService.getModelsByName(permissionGroup.permissionGroup).filter((v, i) => v.parentRole === role.role);
                    // schema.parent_id = filtered_models[0].id;
                    // const exec = exclusions.filter((v, i) => v.belongsTo === this.dataService.getModelById(permission.parent_id).parentRole);
                    schema.parent_id = permission.old_id;
                    const oldModel = this.dataService.getModelById(permission.old_id);
                    if (oldModel && oldModel.parentRole && oldModel.parentRole === this.masterRole) {
                        // this.dataService.addSchema(schema);
                    } else if (oldModel && oldModel.belongsTo === this.masterRole && oldModel.parentRole === '') {
                        // this.dataService.addSchema(schema);
                    }
                    this.setPermissionExcludedStyle(permission.name, 'reset');
                    this.dataService.deleteSchema(permission);
                    this.excludedPermissions = this.excludedPermissions.filter((v, i) => v !== permission.name);
                }
            });
        } else if (!this.excludedPermissions.includes(permission.name)) {
            if (parentModel && parentModel.name === 'Permissions' && parentModel.type === this.masterRole) {
                const dialogRef = this.dialog.open(DeletePermissionGroupDialogComponent, {
                    width: '250px',
                    data: {deleteAction: this.deleteAction, type: 'Permission'}
                });

                dialogRef.afterClosed().subscribe(result => {
                    this.deleteAction = result;
                    if (this.deleteAction === 'removeFromRole') {
                        this.dataService.deleteSchema(permission);
                    } else if (this.deleteAction === 'excludePermissions') {
                        this.excludePermission(permission);
                    }
                });
            } else {
                const dialogRef = this.dialog.open(ConfirmExclusionsDialogComponent, {
                    width: '500px',
                    data: {type: 'Permission', action: 'add', name: permission.display_name}
                });
                dialogRef.afterClosed().subscribe(result => {
                    if (result === 'yes') {
                        this.excludePermission(permission);
                    }
                });
            }
        } else {
            this.platform.openSnackBar(permission.display_name + ' is already excluded', 'Error', {
                duration: 2000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        // this.tryArrangeBlocks(false);
        // setTimeout(() => {
        //     for (const dmodel of this.models) {
        //         this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
        //     }
        //     //this.jsPlumbService.repaintEverything();
        // }, 1000);
    }

    excludePermission(permission) {
        const schema = new Schema();
        schema.name = permission.name;
        schema.display_name = permission.display_name;
        schema.type = 'text';
        schema.input_type = 'text';
        // let filtered_models = this.dataService.getModelsByName(permissionGroup.permissionGroup).filter((v, i) => v.parentRole === role.role);
        // schema.parent_id = filtered_models[0].id;
        const exclusions = this.dataService.getModelsByName('Exclusions');
        // const exec = exclusions.filter((v, i) => v.belongsTo === this.dataService.getModelById(permission.parent_id).parentRole);
        schema.dbId = permission.dbId;
        schema['old_id'] = permission.parent_id;
        schema.parent_id = exclusions[0].id;
        // this.modelPreview.schemas.push(schema);
        this.dataService.addSchema(schema);
        this.setPermissionExcludedStyle(permission.name, 'set');
        this.excludedPermissions.push(permission.name);
        // if (parentModel.parentRole === this.masterRole || (parentModel.parentRole === '' && parentModel.belongsTo === this.masterRole)) {
        //     // this.dataService.deleteSchema(permission);
        // }
    }

    clearCanvas() {
        this.models = [];
        this.links = [];
        this.excludedPermissions = [];
        this.createdRoles = [];
        this.userAddedPermissions = [];
        this.userAddedPermissionGroups = [];
        this.masterRole = '';
        // this.currentAction = '';
        // this.currentActionName = '';
        // this.isNewRoleCreated = false;
        // this.isNewPermissionGroupCreated = false;
        this.jsPlumbService.clearCanvas();

    }

    drop(ev) {
        ev.preventDefault();
        if (this.highlightedModel) {
            document.getElementById(this.highlightedModel.getElementId()).style.border = 'none';
        }

        // for (const model of this.highlightedModels) {
        //     document.getElementById(model.getElementId()).style.border = 'none';
        // }
        // var data = ev.dataTransfer.getData("text");
        // ev.target.appendChild(document.getElementById(data));
    }

    allowDrop(ev) {
        ev.preventDefault();
    }

    drag(ev, type, entity) {
        // $('#drag').draggable();
        const temp = {
            type: type,
            entity: entity
        };
        ev.dataTransfer.setData('data', JSON.stringify(temp));
        if (type === 'permissionGroup') {
            this.highlightedModel = this.dataService.getModelByName('Permission Groups');
        } else if (type === 'permission') {
            this.highlightedModel = this.dataService.getModelByName('Permissions');
        } else if (type === 'role') {
            this.highlightedModel = this.dataService.getModelByName('Roles');
        }

        if (this.highlightedModel) {
            document.getElementById(this.highlightedModel.getElementId()).style.border = '2px dashed green';
        }
        // for (const model of this.highlightedModels) {
        //     document.getElementById(model.getElementId()).style.border = '2px dashed green';
        // }
    }


    attachPermissionGroup(connection) {
        const permissionGroup = connection.target;
        if (connection.source.type === this.masterRole) {
            if (!this.userAddedPermissionGroups.includes(permissionGroup.permissionGroup)) {
                const newModel = new Model();
                newModel.name = permissionGroup.permissionGroup;
                newModel.display_name = permissionGroup.display_name && permissionGroup.display_name !== '' ? permissionGroup.display_name : permissionGroup.permissionGroup;
                newModel.use_soft_delete = false;
                newModel.previewBlock = false;
                newModel.type = 'permissionGroup';
                newModel.belongsTo = 'Permission Groups';
                newModel.parentRole = connection.source.type;
                newModel.dbId = permissionGroup.id;
                newModel.id = this.dataService.data.getNewModelId();
                // newModel.pos_x = this.modelPreview.pos_x;
                // newModel.pos_y = this.modelPreview.pos_y;
                // this.dataService.addModel(newModel);


                for (const permission of permissionGroup.permissions) {
                    const schema = new Schema();
                    schema.name = permission.permission;
                    schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                    schema.dbId = permission.id;
                    schema.type = 'text';
                    schema.input_type = 'text';
                    schema.parent_id = newModel.id;
                    schema.id = newModel.getNewSchemaId();
                    newModel.schemas.push(schema);
                    // this.dataService.addSchema(schema);
                }
                this.userAddedPermissionGroups.push(permissionGroup.permissionGroup);
                connection.source.childModels.push(newModel);
                setTimeout(() => {
                    // this.models.push(newModel);
                    // this.models.push(connection.source);
                    // this.jsPlumbService.createConnection(connection.source, newModel);
                    // this.links.push({from: connection.source.getElementId(), to: newModel.getElementId()});
                    this.tryArrangeBlocks(false);
                    setTimeout(() => {
                        for (const dmodel of this.models) {
                            // if (dmodel.getElementId() !== this.dataService.getModelByName(this.masterRole).getElementId()) {
                            this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                            // }

                        }
                        // this.jsPlumbService.initModel(newModel);
                        this.jsPlumbService.repaintEverything();
                    }, 3000);
                }, 1000);
            } else {
                this.platform.openSnackBar(permissionGroup.display_name + ' is already present', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }

        }
    }

    attachPermission(connection) {
        const permission = connection.target;
        if (connection.source.type === this.masterRole || connection.source.previewBlock) {
            if (!this.userAddedPermissions.includes(permission.permission)) {
                const schema = new Schema();
                schema.name = permission.permission;
                schema.display_name = permission.display_name && permission.display_name !== '' ? permission.display_name : permission.permission;
                schema.dbId = permission.id;
                schema.type = 'text';
                schema.input_type = 'text';
                schema.parent_id = connection.source.id;
                this.userAddedPermissions.push(permission.permission);
                this.dataService.addSchema(schema);
                // if (connection.source.belongsTo !== '') {
                //     this.tryArrangeBlocks(false);
                //     setTimeout(() => {
                //         for (const dmodel of this.models) {
                //             this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                //         }
                //         this.jsPlumbService.repaintEverything();
                //     }, 1000);
                // }
            } else {
                this.platform.openSnackBar(permission.display_name + ' is already present', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }
    }

    attachRole(connection) {
        const role = connection.target;
        if (!this.createdRoles.includes(role.role) && (connection.source.type === this.masterRole)) {
            this.models = [];
            this.createExistingRole(role);
            setTimeout(() => {
                // this.jsPlumbService.createConnection(connection.source, this.dataService.getModelByName(role.role));
                this.links.push({from: connection.source.getElementId(), to: this.dataService.getModelByName(role.role).getElementId()});
                this.tryArrangeBlocks(true);
                setTimeout(() => {
                    for (const dmodel of this.models) {
                        this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
                    }
                    this.jsPlumbService.repaintEverything();
                }, 1000);
            }, 1000);
        }
    }

    async checkDuplicate(entity, attribute, name) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', 'access', 'access', entity, 'partner.eq=' + this.inputPartner + '&' + attribute + '.eq=' + name).subscribe(result => {
                let records: any;
                records = result;
                if (records.length) {
                    resolve(true);
                } else {
                    resolve(false);
                }

            });
        });
    }

    async saveRole(saveAs = '') {
        const partner = localStorage.getItem('partner').split('-');
        const account = localStorage.getItem('account').split('-');
        if (this.currentAction === 'Permission Group' && this.masterRole !== '') {
            const model = this.dataService.getModelByName(this.currentActionName);
            const permissionsAdded = [];
            for (const permission of model.schemas) {
                permissionsAdded.push(permission.dbId);
            }
            const payload = {
                'permissionGroup': saveAs === '' ? this.currentActionName : saveAs,
                'display_name': saveAs === '' ? this.currentActionName : saveAs,
                'permissions': permissionsAdded,
                'partner': this.inputPartner,
                'account': this.inputAccount,
                'type': this.isSuperAdmin && this.inputPartner.includes('admin-') ? 'platform' : 'account'
            };
            if (this.isNewPermissionGroupCreated) {
                this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissiongroups').subscribe(result => {
                    this.platform.openSnackBar('Permission group added successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loadPermissionGroups();
                    this.clearCanvas();
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while adding the permission group. Please try again after sometime.');
                });
            } else {
                this._service.patchItemUpdate(model.dbId.toString(), payload, 'v1', environment.accessPartner, environment.accessPartner, 'permissiongroups').subscribe(result => {
                    this.platform.openSnackBar('Permission group updated successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loadPermissionGroups();
                    this.clearCanvas();
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while saving the permission group. Please try again after sometime.');
                });
            }

        } else if (this.currentAction === 'Role' && this.masterRole !== '') {
            const models = this.data.models.filter((v, i) => v.parentRole === this.masterRole);
            const permissionGroups = [];
            const permissions = [];
            const roles = [];
            const exclusions = [];
            for (const model of models) {
                if (model.type === 'role') {
                    roles.push(this.dbRoles[model.name]);
                }
            }

            for (const permissionGroup of this.dataService.getModelByName('Permission Groups').childModels) {
                permissionGroups.push(permissionGroup.dbId);
            }

            const permissionsList = this.dataService.getModelByName('Permissions');
            for (const permission of permissionsList.schemas) {
                permissions.push(permission.dbId);
            }
            const exclusionsList = this.dataService.getModelByName('Exclusions');
            for (const exclusion of exclusionsList.schemas) {
                exclusions.push(exclusion.dbId);
            }
            const payload = {
                'role': saveAs === '' ? this.masterRole : saveAs,
                'permission_groups': permissionGroups,
                'permissions': permissions,
                'roles': roles,
                'exclusions': exclusions,
                'partner': this.inputPartner,
                'account': this.inputAccount,
                'type': this.isSuperAdmin && this.inputPartner.includes('admin-') ? 'platform' : 'account'
            };
            if (this.isNewRoleCreated) {
                // this._service.InsertRole(payload).subscribe(result => {
                //     this.platform.openSnackBar('Role saved successfully.', 'Success', {
                //         duration: 3000,
                //         verticalPosition: 'top',
                //         horizontalPosition: 'center'
                //     });

                this._service.addItem(payload, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(result => {
                    this.platform.openSnackBar('Role added successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loadRoles();
                    this.clearCanvas();
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while saving the role. Please try again after sometime.');
                });
            } else {
                this._service.patchItemUpdate(this.dbRoles[this.masterRole], payload, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(result => {
                    this.platform.openSnackBar('Role saved successfully.', 'Success', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loadRoles();
                    this.clearCanvas();
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while saving the role. Please try again after sometime.');
                });
            }
        }
    }

    async saveAs(newRoleName = '') {
        // let newRoleName = '';
        if (this.masterRole !== '') {
            const dialogRef = this.dialog.open(NewRoleDialogComponent, {
                width: '250px',
                data: {name: newRoleName, action: 'Role'}
            });

            dialogRef.afterClosed().subscribe(async result => {
                newRoleName = result;
                if (newRoleName && newRoleName !== '' && newRoleName !== ' ') {
                    this.closeSaveAsDialog(newRoleName);
                }
                // this.closeNameInputForm();
            });
        }
    }


    async closeSaveAsDialog(newRoleName) {
        if (this.currentAction === 'Role') {
            const res = await this.checkDuplicate('roles', 'role', newRoleName);
            if (!res) {
                this.currentAction = 'Role';
                this.isNewRoleCreated = true;
                this.saveRole(newRoleName);
            } else {
                this.platform.openSnackBar('Role named ' + this.currentActionName + ' alredy exsists', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.saveAs(newRoleName);
            }
        }
        if (this.currentAction === 'Permission Group') {
            const res = await this.checkDuplicate('permissiongroups', 'permissionGroup', newRoleName);
            if (!res) {
                this.currentAction = 'Permission Group';
                this.isNewPermissionGroupCreated = true;
                this.saveRole(newRoleName);
            } else {
                this.platform.openSnackBar('Permission group named ' + this.currentActionName + ' alredy exsists', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.saveAs(newRoleName);
            }
        }
    }

    layoutChanged() {
        const permissionGroupModels = this.dataService.getModelsByName('Permission Groups');
        const permissionModels = this.dataService.getModelsByName('Permissions');
        if (permissionGroupModels && permissionGroupModels.length) {
            for (const permissionGroupModel of permissionGroupModels) {
                const id = '#schema' + permissionGroupModel.getElementId();
                // $(permissionGroupModel.getElementId()).toggleClass('fa-chevron-up fa-chevron-down');;
                if ($(id).hasClass('in')) {
                    $(id).removeClass('in');
                }
                // $(id).hasClass('in') ? $(id).removeClass('in') : $(id).addClass('in');
                // document.getElementById(permissionGroupModel.getElementId()).style.display = 'none';
            }
        }
        if (permissionModels && permissionModels.length) {
            for (const permissionModel of permissionModels) {
                const id = '#schema' + permissionModel.getElementId();
                // $(permissionGroupModel.getElementId()).toggleClass('fa-chevron-up fa-chevron-down');;
                if ($(id).hasClass('in')) {
                    $(id).removeClass('in');
                }
                // document.getElementById(permissionModel.getElementId()).style.display = 'none';
            }
        }
        this.tryArrangeBlocks(false);
        setTimeout(() => {
            for (const dmodel of this.models) {

                this.jsPlumbService.revalidate(document.getElementById(dmodel.getElementId()));
            }
            this.jsPlumbService.repaintEverything();
        }, 1000);
    }

    save() {
        $('.content').addClass('shrink');
    }

    createRole() {
        $('.table-responsive').attr('class', 'table-responsive col-md-2');
        $('.visual-editor').show();
        this.operation = 'create';
        this.create = true;
        this.rightPanel = false;
    }

    cancel() {
        this.create = false;
        this.columns = this.columnCopy;
    }

    getId() {
        return (new Date().getTime()) * 1000 + Math.floor(Math.random() * 1001);
    }


    deleteRecordFromDb(id, name, entity) {
        if (confirm('This action is irreversible, Are you sure you want to delete ' + name)) {
            this._service.deleteItem(id.toString(), 'v1', 'access', 'access', entity).subscribe(response => {
                this.platform.openSnackBar('Deleted successfully', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                if (name === this.masterRole) {
                    this.clearCanvas();
                }
                switch (entity) {
                    case 'roles':
                        this.loadRoles();
                        break;
                    case 'permissiongroups':
                        this.loadPermissionGroups();
                        break;
                    case 'permissions':
                        this.loadPermissions();
                        break;
                }
            }, error => {
                this.platform.openSnackBar('Error while deleting this record: ' + error.error.message, 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }

    }

    getTrimmedName(role) {
        const trimmedName = role.split('=>');
        if (trimmedName && trimmedName.length) {
            return trimmedName[trimmedName.length - 1];
        }
    }

    deleteRecord(id) {
        if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
            this._service.deleteRole(localStorage.getItem('partner'), localStorage.getItem('account'), id).subscribe(
                agents => {
                    this.platform.openSnackBar('Deleted successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    const itemDuplicate = this.items;
                    const deleteditem = itemDuplicate.findIndex(p => p && p.id === id);
                    delete this.items[deleteditem];
                    //  this.removeItemFromUI(event);
                },
                error => {
                    this.platform.openSnackBar('Error while deleting this record: ' + error.error.message, 'Error', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            );
        } else {
        }
    }
}

@Component({
    selector: 'delete-permission-group-dialog',
    templateUrl: 'delete-permission-group-dialog.html',
    styleUrls: ['./manage-roles.component.css']
})
export class DeletePermissionGroupDialogComponent {

    constructor(
        private partnerSettingsService: PartnerSettingsService,
    public dialogRef: MatDialogRef<DeletePermissionGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

}

@Component({
    selector: 'new-role-group-dialog',
    templateUrl: 'new-role-dialog.html',
    styleUrls: ['./manage-roles.component.css']
})
export class NewRoleDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<NewRoleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RoleDialogData) {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

}

@Component({
    selector: 'confirm-exclusions-dialog',
    templateUrl: 'confirm-exclusions-dialog.html',
    styleUrls: ['./manage-roles.component.css']
})
export class ConfirmExclusionsDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<NewRoleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ExclusionsDialogData) {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

}
